export const landListings = [
  {
    id: "LND-001",
    title: "Prime Highway-Facing Commercial Plot",
    category: "Commercial",
    location: "NH 44, Hosur, Tamil Nadu",
    size: "2.4 Acres",
    sizeSqft: "104,544 sq.ft",
    expectedRent: "₹6.5 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Large%20highway%20facing%20commercial%20land%20plot%20with%20billboard%20potential%2C%20clear%20flat%20terrain%2C%20modern%20India%20highway%20infrastructure%2C%20dramatic%20late%20afternoon%20golden%20hour%20lighting%2C%20deep%20teal%20and%20warm%20amber%20sky%2C%20cinematic%20real%20estate%20photography%2C%20wide%20angle%20aerial%20perspective%2C%20Karnataka%20Tamil%20Nadu%20border%20area%2C%20highly%20detailed&width=800&height=500&seq=listing-com-hosur-01&orientation=landscape",
    description: "Premium highway-facing plot on NH 44 with 180m road frontage. Ideal for QSR drive-thru, fuel station, retail showroom, or EV charging hub. High visibility from both directions.",
    features: ["180m highway frontage", "3-phase electricity", "Water borewell", "Clear title", "Fenced boundary"],
    postedDate: "2 days ago",
    useCases: ["QSR", "Fuel Station", "EV Charging", "Showroom"],
  },
  {
    id: "LND-002",
    title: "Large Industrial Warehouse Plot",
    category: "Industrial",
    location: "Nelamangala, Bengaluru Rural, Karnataka",
    size: "5.8 Acres",
    sizeSqft: "252,648 sq.ft",
    expectedRent: "₹9.2 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Large%20flat%20industrial%20land%20parcel%20with%20access%20road%2C%20clear%20level%20terrain%20ready%20for%20warehouse%20construction%2C%20dramatic%20dusk%20sky%2C%20India%20industrial%20zone%2C%20cinematic%20wide%20angle%20photography%2C%20deep%20teal%20and%20amber%20lighting%2C%20Bengaluru%20industrial%20outskirts%2C%20highly%20detailed&width=800&height=500&seq=listing-ind-nelamangala-02&orientation=landscape",
    description: "Vast level industrial plot 4km from Nelamangala toll plaza. Excellent for logistics warehouse, cold storage, or e-commerce fulfillment center. Direct truck access from main road.",
    features: ["4km from NH 4", "Truck accessible", "3-phase HT power", "No FSI restriction", "Drainage ready"],
    postedDate: "1 week ago",
    useCases: ["Warehouse", "Cold Storage", "Logistics Hub", "Data Center"],
  },
  {
    id: "LND-003",
    title: "Scenic Lakeside Agricultural Land",
    category: "Agricultural",
    location: "Kanakapura Road, Ramanagara, Karnataka",
    size: "12 Acres",
    sizeSqft: "522,720 sq.ft",
    expectedRent: "₹4.8 Lakhs/month",
    status: "Under Review",
    statusColor: "bg-secondary-500/15 text-secondary-700",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20scenic%20agricultural%20land%20with%20lake%20view%2C%20green%20vegetation%2C%20open%20sky%2C%20peaceful%20countryside%20setting%2C%20Karnataka%20rural%20landscape%2C%20dramatic%20golden%20hour%20lighting%20with%20warm%20tones%2C%20cinematic%20nature%20photography%2C%20wide%20angle%20view%2C%20highly%20detailed&width=800&height=500&seq=listing-agri-kanakapura-03&orientation=landscape",
    description: "Stunning 12-acre agricultural parcel with 200m lake frontage. Perfect for eco-resort, glamping, organic farming, or agritourism venture. Breathtaking sunset views year-round.",
    features: ["200m lake frontage", "Natural well water", "Mango orchard", "Road access", "Solar ready"],
    postedDate: "3 days ago",
    useCases: ["Eco-Resort", "Glamping", "Organic Farm", "Agritourism"],
  },
  {
    id: "LND-004",
    title: "Corner Plot — Retail & Commercial Hub",
    category: "Commercial",
    location: "Whitefield Main Road, Bengaluru, Karnataka",
    size: "0.8 Acres",
    sizeSqft: "34,848 sq.ft",
    expectedRent: "₹12 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Premium%20corner%20commercial%20land%20plot%20in%20urban%20setting%2C%20clear%20flat%20land%2C%20Bengaluru%20Whitefield%20area%2C%20modern%20India%20city%20outskirts%2C%20dramatic%20dusk%20ambiance%2C%20street%20lights%2C%20cinematic%20real%20estate%20photography%2C%20warm%20amber%20and%20teal%20tones%2C%20highly%20detailed&width=800&height=500&seq=listing-com-whitefield-04&orientation=landscape",
    description: "Rare corner plot on Whitefield Main Road with dual road frontage. 800m from ITPL. Zoned for commercial — perfect for supermarket, bank branch, or multi-brand retail complex.",
    features: ["Dual road frontage", "800m to ITPL", "Commercial zoning", "Metro station nearby", "24x7 water"],
    postedDate: "5 days ago",
    useCases: ["Supermarket", "Bank Branch", "Retail Complex", "Restaurant"],
  },
  {
    id: "LND-005",
    title: "Mysore Highway Industrial Land Parcel",
    category: "Industrial",
    location: "Bidadi, Bengaluru-Mysore Highway, Karnataka",
    size: "7.2 Acres",
    sizeSqft: "313,632 sq.ft",
    expectedRent: "₹7.8 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Expansive%20industrial%20land%20on%20Mysore%20highway%2C%20clear%20flat%20terrain%20with%20distant%20factory%20backdrop%2C%20dramatic%20evening%20sky%2C%20India%20industrial%20corridor%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20amber%20light%2C%20Bengaluru%20Mysore%20expressway%20area%2C%20highly%20detailed&width=800&height=500&seq=listing-ind-bidadi-05&orientation=landscape",
    description: "KIADB-approved industrial land with direct access to Bengaluru-Mysore Expressway. 500m from Toyota Kirloskar plant. Ready for immediate development — all clearances obtained.",
    features: ["KIADB approved", "Expressway access", "Near Toyota plant", "All clearances done", "Power substation nearby"],
    postedDate: "1 day ago",
    useCases: ["Manufacturing", "Assembly Plant", "Logistics Park", "Warehouse"],
  },
  {
    id: "LND-006",
    title: "Event & Wedding Venue Land",
    category: "Agricultural",
    location: "Yelahanka, North Bengaluru, Karnataka",
    size: "3.5 Acres",
    sizeSqft: "152,460 sq.ft",
    expectedRent: "₹3.2 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20open%20green%20field%20suitable%20for%20outdoor%20events%20and%20wedding%20venue%2C%20manicured%20lawn%20potential%2C%20clear%20sky%2C%20trees%20in%20distance%2C%20North%20Bengaluru%20countryside%2C%20dramatic%20golden%20hour%2C%20cinematic%20wedding%20venue%20photography%2C%20warm%20inviting%20atmosphere%2C%20highly%20detailed&width=800&height=500&seq=listing-agri-yelahanka-06&orientation=landscape",
    description: "Flat manicured land in Yelahanka — the wedding venue hub of Bengaluru. Walking distance from multiple resorts. Ready parking area for 200+ cars. 3-phase power on site.",
    features: ["Parking for 200 cars", "3-phase power", "Manicured lawns", "Near resorts", "Easy road access"],
    postedDate: "2 weeks ago",
    useCases: ["Wedding Venue", "Event Space", "Concert Ground", "Film Shoot"],
  },
  {
    id: "LND-007",
    title: "EV Charging & QSR Highway Strip",
    category: "Commercial",
    location: "NH 48, Tumkur Road, Karnataka",
    size: "1.2 Acres",
    sizeSqft: "52,272 sq.ft",
    expectedRent: "₹5.1 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Narrow%20highway%20frontage%20commercial%20strip%20land%2C%20clear%20leveled%20plot%2C%20national%20highway%20with%20vehicle%20traffic%20in%20distance%2C%20dramatic%20dusk%20sky%2C%20India%20highway%20commercial%20real%20estate%2C%20warm%20amber%20and%20teal%20cinematic%20lighting%2C%20highly%20detailed&width=800&height=500&seq=listing-com-tumkur-07&orientation=landscape",
    description: "Narrow but deep highway strip with 80m frontage on NH 48. Perfect for multi-brand setup — EV charging + QSR + restroom complex. Daily traffic exceeds 45,000 vehicles.",
    features: ["80m NH 48 frontage", "45k daily vehicles", "3-phase power", "Approved access point", "Water connection"],
    postedDate: "4 days ago",
    useCases: ["EV Charging", "QSR", "Fuel Station", "Dhaba"],
  },
  {
    id: "LND-008",
    title: "Multi-Purpose Logistics Land",
    category: "Industrial",
    location: "Hoskote, Bengaluru East, Karnataka",
    size: "8.5 Acres",
    sizeSqft: "370,260 sq.ft",
    expectedRent: "₹10.5 Lakhs/month",
    status: "Under Review",
    statusColor: "bg-secondary-500/15 text-secondary-700",
    image: "https://readdy.ai/api/search-image?query=Vast%20industrial%20logistics%20land%20with%20container%20trucks%20in%20distance%2C%20clear%20level%20ground%2C%20Bengaluru%20east%20industrial%20belt%2C%20dramatic%20afternoon%20light%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20amber%20and%20teal%20tones%2C%20India%20logistics%20real%20estate%2C%20highly%20detailed&width=800&height=500&seq=listing-ind-hoskote-08&orientation=landscape",
    description: "Huge flat parcel near Hoskote Industrial Area. Adjacent to existing Amazon and Flipkart warehouses. All approvals in place for Grade A logistics park development.",
    features: ["Near Amazon FC", "Grade A ready", "Container accessible", "Government approved", "Water & power ready"],
    postedDate: "6 days ago",
    useCases: ["Logistics Park", "E-commerce FC", "Cold Chain", "Cross-dock"],
  },
  {
    id: "LND-009",
    title: "Agro-Tourism Farm Stay Land",
    category: "Agricultural",
    location: "Nandi Hills Road, Chikkaballapur, Karnataka",
    size: "15 Acres",
    sizeSqft: "653,400 sq.ft",
    expectedRent: "₹2.9 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Rolling%20hills%20agricultural%20land%20with%20stunning%20mountain%20view%2C%20Nandi%20Hills%20backdrop%2C%20green%20farmland%2C%20dramatic%20morning%20mist%20and%20golden%20sunrise%2C%20Karnataka%20countryside%2C%20cinematic%20landscape%20photography%2C%20warm%20natural%20tones%2C%20highly%20detailed%20scenic%20beauty&width=800&height=500&seq=listing-agri-nandi-09&orientation=landscape",
    description: "Breathtaking 15-acre parcel with Nandi Hills as backdrop. Existing farmhouse, mature fruit orchard, and natural spring. Ready for premium farm-stay or wellness retreat development.",
    features: ["Hill view backdrop", "Existing farmhouse", "Natural spring", "Fruit orchard", "Gated access"],
    postedDate: "1 week ago",
    useCases: ["Farm Stay", "Wellness Retreat", "Organic Farm", "Yoga Center"],
  },
  {
    id: "LND-010",
    title: "Petrol Pump Approved Highway Site",
    category: "Commercial",
    location: "NH 75, Kolar Highway, Karnataka",
    size: "0.6 Acres",
    sizeSqft: "26,136 sq.ft",
    expectedRent: "₹4.2 Lakhs/month",
    status: "Leased",
    statusColor: "bg-primary-500/15 text-primary-700",
    image: "https://readdy.ai/api/search-image?query=Highway%20frontage%20commercial%20land%20with%20petrol%20pump%20potential%2C%20clear%20leveled%20site%20on%20national%20highway%2C%20India%20roadside%20commercial%20real%20estate%2C%20dramatic%20evening%20sky%2C%20cinematic%20photography%2C%20warm%20amber%20and%20teal%20tones%2C%20highway%20setting&width=800&height=500&seq=listing-com-kolar-10&orientation=landscape",
    description: "Recently leased! This site demonstrates what's possible — a 0.6-acre highway plot leased to a major oil company at ₹4.2L/month for 15 years. Similar sites available on request.",
    features: ["Lease signed", "Oil company tenant", "15-year agreement", "75m frontage", "Similar sites available"],
    postedDate: "Just leased",
    useCases: ["Petrol Pump", "Fuel Station", "EV Hub", "Rest Stop"],
  },
  {
    id: "LND-011",
    title: "Solar Farm Ready Land Parcel",
    category: "Agricultural",
    location: "Pavagada, Tumkur, Karnataka",
    size: "25 Acres",
    sizeSqft: "1,089,000 sq.ft",
    expectedRent: "₹5.6 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Large%20flat%20arid%20land%20ideal%20for%20solar%20farm%20installation%2C%20clear%20open%20sky%2C%20minimal%20vegetation%2C%20India%20solar%20energy%20potential%20site%2C%20dramatic%20afternoon%20sun%2C%20cinematic%20wide%20angle%20landscape%20photography%2C%20warm%20amber%20tones%2C%20Karnataka%20dry%20region%2C%20highly%20detailed&width=800&height=500&seq=listing-agri-pavagada-11&orientation=landscape",
    description: "25 acres of flat arid land in Asia's largest solar park region. 33kV substation 2km away. Existing solar farms on adjacent parcels. 25-year lease potential with government-backed PPA.",
    features: ["33kV substation 2km", "Solar park zone", "Flat terrain", "Minimal vegetation", "Government PPA ready"],
    postedDate: "3 days ago",
    useCases: ["Solar Farm", "Wind Energy", "Energy Storage", "Agri-voltaics"],
  },
  {
    id: "LND-012",
    title: "Urban Infill Warehouse Plot",
    category: "Industrial",
    location: "Peenya Industrial Area, Bengaluru, Karnataka",
    size: "1.5 Acres",
    sizeSqft: "65,340 sq.ft",
    expectedRent: "₹8.9 Lakhs/month",
    status: "Available",
    statusColor: "bg-accent-500/15 text-accent-700",
    image: "https://readdy.ai/api/search-image?query=Urban%20industrial%20infill%20land%20plot%20surrounded%20by%20factories%2C%20clear%20flattened%20terrain%2C%20Peenya%20Bengaluru%20industrial%20estate%2C%20dramatic%20afternoon%20light%2C%20cinematic%20industrial%20photography%2C%20warm%20amber%20and%20teal%20tones%2C%20India%20manufacturing%20hub%2C%20highly%20detailed&width=800&height=500&seq=listing-ind-peenya-12&orientation=landscape",
    description: "Rare infill industrial plot inside established Peenya Industrial Area. 500m from Peenya Metro. Last-mile dark store or micro-fulfillment center. All utilities connected.",
    features: ["Inside Peenya IA", "500m to Metro", "All utilities live", "Gated compound", "24x7 access"],
    postedDate: "2 days ago",
    useCases: ["Dark Store", "Micro-FC", "Last Mile Hub", "Cold Storage"],
  },
];

export const categoryFilters = [
  { label: "All Listings", value: "All", icon: "ri-global-line" },
  { label: "Commercial", value: "Commercial", icon: "ri-store-2-line" },
  { label: "Industrial", value: "Industrial", icon: "ri-building-4-line" },
  { label: "Agricultural", value: "Agricultural", icon: "ri-plant-line" },
];